import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ChatBotEFComponent} from "./chat-bot-ef.component";

const routes: Routes = [
  { path: '', component: ChatBotEFComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatBotEfRoutingModule { }
